import { gql } from '@apollo/client';

export const BOOKINGS = gql`
    query bookings($dateString: String!) {
        bookings(dateString: $dateString) {
            id
            merchantId
            createdAt
            customer {
                name
                email
                phoneNumber
                guestNum
                address
                postcode
                foodAllergies
                geolocation {
                    longitude
                    latitude
                }
            }
            bookingDetails {
                bookingTime
                numberOfGuests
                specialInstructions
                promotionId
            }
        }
    }
`;

export const BOOKING = gql`
    query booking($dateString: String!, $bookingId: String!) {
        booking(dateString: $dateString, bookingId: $bookingId) {
            id
            merchantId
            createdAt
            customer {
                name
                email
                phoneNumber
                guestNum
                address
                postcode
                foodAllergies
                geolocation {
                    longitude
                    latitude
                }
            }
            bookingDetails {
                bookingTime
                numberOfGuests
                specialInstructions
                promotionId
            }
        }
    }
`;

export const SQL_BOOKINGS = gql`
    query sqlBookings($filter: BookingFilterInput, $sort: BookingSortInput, $first: Int, $after: String, $last: Int, $before: String) {
        sqlBookings(filter: $filter, sort: $sort, first: $first, after: $after, last: $last, before: $before) {
            edges {
                node {
                    id
                    bookingNumber
                    referenceNumber
                    assignedTablesRaw
                    merchantId
                    yearStr
                    bookingTime
                    createdAt
                    updatedAt
                    deletedAt
                    userId
                    customerName
                    customerPhone
                    customerEmail
                    numberOfAdults
                    numberOfChildren
                    minSpend
                    note
                    internalNote
                    mark
                    status
                    preAuthStatus
                    staffLabel
                    source
                    merchantName
                    merchantAltName
                    bookingTags
                    activities {
                        timestamp
                        channel
                        action
                        userId
                        details
                    }
                    customerBlockInfo {
                        isBlocked
                        reason
                        blockedAt
                        blockedBy
                    }
                    deposit {
                        amount
                        reference
                        paymentUrl
                    }
                    google {
                        reservationId
                        source
                        syncedAt
                    }
                    updateLogs
                }
                cursor
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
                startCursor
                endCursor
            }
            totalCount
        }
    }
`;

export const SQL_BOOKING_BY_NUMBER = gql`
    query sqlBookingByNumber($merchantId: String!, $bookingNumber: String!, $yearStr: String) {
        sqlBookingByNumber(merchantId: $merchantId, bookingNumber: $bookingNumber, yearStr: $yearStr) {
            id
            bookingNumber
            referenceNumber
            assignedTablesRaw
            merchantId
            yearStr
            bookingTime
            createdAt
            updatedAt
            deletedAt
            userId
            customerName
            customerPhone
            customerEmail
            numberOfAdults
            numberOfChildren
            minSpend
            note
            internalNote
            mark
            status
            preAuthStatus
            staffLabel
            source
            merchantName
            merchantAltName
            bookingTags
            activities {
                timestamp
                channel
                action
                userId
                details
            }
            customerBlockInfo {
                isBlocked
                reason
                blockedAt
                blockedBy
            }
            deposit {
                amount
                reference
                paymentUrl
            }
            google {
                reservationId
                source
                syncedAt
            }
            updateLogs
        }
    }
`;

export const SQL_BOOKINGS_BY_DATE = gql`
    query sqlBookingsByDate($merchantId: String!, $dateString: String!, $filter: BookingFilterInput) {
        sqlBookingsByDate(merchantId: $merchantId, dateString: $dateString, filter: $filter) {
            id
            bookingNumber
            referenceNumber
            assignedTablesRaw
            merchantId
            yearStr
            bookingTime
            createdAt
            updatedAt
            deletedAt
            userId
            customerName
            customerPhone
            customerEmail
            numberOfAdults
            numberOfChildren
            minSpend
            note
            internalNote
            mark
            status
            preAuthStatus
            staffLabel
            source
            merchantName
            merchantAltName
            bookingTags
            activities {
                timestamp
                channel
                action
                userId
                details
            }
            customerBlockInfo {
                isBlocked
                reason
                blockedAt
                blockedBy
            }
            deposit {
                amount
                reference
                paymentUrl
            }
            google {
                reservationId
                source
                syncedAt
            }
            updateLogs
        }
    }
`;

export const BOOKING_COUNTS_REPORT = gql`
    query bookingCountsReport($dateFrom: Float!, $dateTo: Float!, $merchantIds: [String]) {
        bookingCountsReport(dateFrom: $dateFrom, dateTo: $dateTo, merchantIds: $merchantIds) {
            totalBookings
            merchants {
                merchantId
                merchantName
                totalCount
                percentage
            }
            sources {
                source
                totalCount
                percentage
            }
            details {
                merchantId
                merchantName
                source
                count
                percentage
            }
        }
    }
`;

// DailyBookingTrendReport Query
export const DAILY_BOOKING_TREND_REPORT = gql`
    query dailyBookingTrendReport($dateFrom: Float!, $dateTo: Float!, $merchantIds: [String]) {
        dailyBookingTrendReport(dateFrom: $dateFrom, dateTo: $dateTo, merchantIds: $merchantIds) {
            totalBookings
            dailyCounts {
                date
                count
            }
            averagePerDay
            peakDay {
                date
                count
            }
            lowestDay {
                date
                count
            }
        }
    }
`;
